// import React from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { Link } from 'react-router-dom';
// import {makeAuthenticatedDELETERequest} from '../services/serverHelper';
// import { toast } from 'react-toastify';
// import { productPoints } from '../services/apis';
// import { removeFromCart, updateQuantity, clearCart } from '../reducer/slices/cartSlice';
// import MarketplaceNavbar from '../../components/MarketplaceNavbar'
// import './CartPage.css';
// import ProductCard from '../../components/ProductCard';
// import { MdDelete } from "react-icons/md";


// const CartPage = () => {
//   const dispatch = useDispatch();
//   const cartItems = useSelector((state) => state.cart.cartItems);
//   const cartTotal = useSelector((state) => state.cart.cartItems.reduce((total, item) => total + item.pricing.amount, 0));
//   const {accessToken} = useSelector((state) => state.auth);

//   const handleRemoveItem = (productId) => {
//     dispatch(removeFromCart(productId));
//   };

//   // const handleUpdateQuantity = (productId) => {
//   //   dispatch(updateQuantity({ productId }));
//   // };

//   const handleClearCart = async () => {
//     if (window.confirm('Are you sure you want to clear the cart?')) {
//       const response = await makeAuthenticatedDELETERequest(`${productPoints.DELETE_ALL_CART_ITEMS}`,accessToken
// );
//       if (response.statusCode === 200) {
//        dispatch(clearCart());
//        toast.success('Cart cleared successfully!');
//       } else {
//         alert('Failed to clear cart. Please try again.');
//       }
//     }
//   };

//   const handleClearSingleItem = async (productId) => {
//     if (window.confirm('Are you sure you want to remove this item from the cart?')) {
//       const response = await makeAuthenticatedDELETERequest(`${productPoints.DELETE_CART_ITEM}/${productId}`,accessToken );
//       if (response.statusCode === 200) {
//        dispatch(removeFromCart(productId));   
//        toast.success('Item removed from cart successfully!');
//       } else {
//         alert('Failed to remove item from cart. Please try again.');
//       }
//     }
//   };

//   const handlePurchase = ()=>{

//   }

//   if (cartItems.length === 0) {
//     return (
//       <div className="cart-mainpage">
//         <MarketplaceNavbar />
//         <div className='cart-main-content'>
//           <h1 className="cart-title">Shopping Cart</h1>
//           <div className="text-center">
//             <p className="mb-4">Your cart is empty.</p>
//             <Link to="/marketplace" className="btn btn-primary">
//               Continue Shopping
//             </Link>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <MarketplaceNavbar />
//       <div className="cart-main-content">
//         <h1 className="cart-title">Shopping Cart</h1>

//         <div className="cart-items">
//           <div className="cart-item-div">
//             <div className="cart-card">
//               <div className="cart-card-header">
//                 <h5>Cart Items ({cartItems.length})</h5>
//                 <button
//                   className="btn btn-outline-danger btn-sm"
//                   onClick={handleClearCart}
//                 >
//                   Clear Cart
//                 </button>
//               </div>

//               {
//                 cartItems && cartItems.map((product, index)=>{
//                   return(
//                     <div className="card-body">
//                       <div  className="">
//                         <div className="product-card">
//                             <div className="img-container" >                      
//                                 <iframe className='video'
//                                     title='Youtube player'
//                                     ClassName="product-card-img-top"
//                                     // sandbox='allow-same-origin allow-forms allow-popups allow-scripts allow-presentation'
//                                     src={`https://youtube.com/embed/${product.video.youtubeTrailerId}?autoplay=0`}>
//                                 </iframe>
//                                 {/* <div className="bg-secondary d-flex align-items-center justify-content-center text-white" style={{ height: '100%' }}>
//                                   No Image
//                                 </div> */}
//                             </div>
//                             <div className="product-card-body">
//                               <div>
                                
//                               <div className='product-card-body-details'>
//                                 <div>
//                                   <h5 className="product-card-text-title">{product.title}</h5>
//                                 </div>
//                                 <p className="product-cardproduct-price">
//                                   {product.pricing.amount}
//                                 </p>
//                                 </div>
//                                 <div className="product-card-detail">   
//                                   <Link to={`/product-description/${product._id}`} className="link-btn">
//                                     View Description
//                                   </Link>                                  
//                                 </div>
//                                 <button onClick={() => handleClearSingleItem(product._id)} style={{backgroundColor:'transparent', border:'none', color:'red', display:'flex', alignItems:'center', gap:'5px'}}>
//                                   <MdDelete /> Remove from cart
//                                 </button>
//                               </div>
//                               {/* <Link
//                                 to="/CheckOut"
//                                 className="cart-btn"
//                                 onClick={handlePurchase}
//                                 style={{alignContent:'flex-end', textDecoration:'none'}}
//                               >
//                                 Buy
//                               </Link> */}
//                             </div>
//                           </div>
//                       </div> 
//                     </div>
//                   )
//                 })
//               }

//             </div>
//           </div>

//           <div className="cart-checkout">
//             <div className="checkout-card">
//               <div className="card-header">
//                 <h5>Order Summary</h5>
//               </div>
//               <div className="card-body">
//                 <div className="d-flex justify-content-between mb-3">
//                   <span>Subtotal ({cartItems.length} items)</span>
//                   <span>₹{cartTotal}</span>
//                 </div>
//                 <div className="d-flex justify-content-between mb-3">
//                   <span>Shipping</span>
//                   <span>Free</span>
//                 </div>
//                 <hr />
//                 <div className="d-flex justify-content-between mb-3">
//                   <strong>Total</strong>
//                   <strong>₹{cartTotal}</strong>
//                 </div>
//                 <Link to="/Checkout" className="cart-checkout-btn" style={{textDecoration:'none'}}>
//                   Proceed to Checkout
//                 </Link>
//               </div>
//             </div>

//             <div className="mt-3">
//               <Link to="/marketplace" className="btn btn-outline-primary w-100">
//                 Continue Shopping
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>
    
//     </>
//   );
// };

// export default CartPage;



import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { makeAuthenticatedDELETERequest } from '../services/serverHelper';
import { toast } from 'react-toastify';

import { productPoints, partnerPoints } from '../services/apis';

import {
  removeFromCart,
  updateQuantity,
  clearCart
} from '../reducer/slices/cartSlice';

import {
  removeFromPartnerCart,
  clearPartnerCart
} from '../reducer/slices/partnerCartSlice';

import MarketplaceNavbar from '../../components/MarketplaceNavbar';
import './CartPage.css';
import ProductCard from '../../components/ProductCard';
import { MdDelete } from "react-icons/md";


const CartPage = () => {
  const dispatch = useDispatch();

  // Artist Cart
  const cartItems = useSelector(
    (state) => state.cart.cartItems
  );

  // Partner Cart
  const partnerCartItems = useSelector(
    (state) => state.partnerCart.cartItems
  );

  const { accessToken } = useSelector(
    (state) => state.auth
  );

  // Combine both carts only for displaying
  const allCartItems = [
    ...cartItems.map((item) => ({
      ...item,
      cartType: 'artist'
    })),

    ...partnerCartItems.map((item) => ({
      ...item,
      cartType: 'partner'
    }))
  ];

  // Get price according to cart type
  const getItemPrice = (item) => {
    if (item.cartType === 'artist') {
      return Number(item?.pricing?.amount || 0);
    }

    return Number(
      item?.discountPrice ??
      item?.price ??
      0
    );
  };

  // Total of both carts
  const cartTotal = allCartItems.reduce(
    (total, item) => total + getItemPrice(item),
    0
  );


  // ============================================================
  // ARTIST CART
  // ============================================================

  const handleClearCart = async () => {
    if (
      window.confirm(
        'Are you sure you want to clear the cart?'
      )
    ) {
      const response =
        await makeAuthenticatedDELETERequest(
          `${productPoints.DELETE_ALL_CART_ITEMS}`,
          accessToken
        );

      if (response.statusCode === 200) {

        dispatch(clearCart());

        toast.success(
          'Cart cleared successfully!'
        );

      } else {

        alert(
          'Failed to clear cart. Please try again.'
        );

      }
    }
  };


  const handleClearSingleItem = async (productId) => {
    if (
      window.confirm(
        'Are you sure you want to remove this item from the cart?'
      )
    ) {

      const response =
        await makeAuthenticatedDELETERequest(
          `${productPoints.DELETE_CART_ITEM}/${productId}`,
          accessToken
        );

      if (response.statusCode === 200) {

        dispatch(removeFromCart(productId));

        toast.success(
          'Item removed from cart successfully!'
        );

      } else {

        alert(
          'Failed to remove item from cart. Please try again.'
        );

      }
    }
  };


  // ============================================================
  // PARTNER CART
  // ============================================================

  const handleClearPartnerCart = async () => {
    if (
      window.confirm(
        'Are you sure you want to clear the partner cart?'
      )
    ) {

      const response =
        await makeAuthenticatedDELETERequest(
          `${partnerPoints.DELETE_ALL_PARTNER_CART_ITEMS}`,
          accessToken
        );

      if (response.statusCode === 200) {

        dispatch(clearPartnerCart());

        toast.success(
          'Partner cart cleared successfully!'
        );

      } else {

        alert(
          'Failed to clear partner cart. Please try again.'
        );

      }
    }
  };


  const handleClearSinglePartnerItem = async (productId) => {
    if (
      window.confirm(
        'Are you sure you want to remove this item from the cart?'
      )
    ) {

      const response =
        await makeAuthenticatedDELETERequest(
          `${partnerPoints.DELETE_PARTNER_CART_ITEM}/${productId}`,
          accessToken
        );

      if (response.statusCode === 200) {

        dispatch(
          removeFromPartnerCart(productId)
        );

        toast.success(
          'Partner item removed from cart successfully!'
        );

      } else {

        alert(
          'Failed to remove item from cart. Please try again.'
        );

      }
    }
  };


  // ============================================================
  // EMPTY CART
  // ============================================================

  if (allCartItems.length === 0) {
    return (
      <div className="cart-mainpage">

        <MarketplaceNavbar />

        <div className='cart-main-content'>

          <h1 className="cart-title">
            Shopping Cart
          </h1>

          <div className="text-center">

            <p className="mb-4">
              Your cart is empty.
            </p>

            <Link
              to="/marketplace"
              className="btn btn-primary"
            >
              Continue Shopping
            </Link>

          </div>

        </div>

      </div>
    );
  }


  // ============================================================
  // CART PAGE
  // ============================================================

  return (
    <>
      <MarketplaceNavbar />

      <div className="cart-main-content">

        <h1 className="cart-title">
          Shopping Cart
        </h1>


        <div className="cart-items">

          <div className="cart-item-div">

            <div className="cart-card">

              <div className="cart-card-header">

                <h5>
                  Cart Items ({allCartItems.length})
                </h5>

                {/* Keep separate clear buttons
                    because Artist and Partner carts
                    are separate in backend */}

                <div
                  style={{
                    display: 'flex',
                    gap: '8px'
                  }}
                >

                  {cartItems.length > 0 && (
                    <button
                      className="btn btn-outline-danger btn-sm"
                      onClick={handleClearCart}
                    >
                      Clear Artist Cart
                    </button>
                  )}

                  {partnerCartItems.length > 0 && (
                    <button
                      className="btn btn-outline-danger btn-sm"
                      onClick={handleClearPartnerCart}
                    >
                      Clear Partner Cart
                    </button>
                  )}

                </div>

              </div>


              {
                allCartItems.map((product, index) => {

                  const isPartner =
                    product.cartType === 'partner';

                  const price =
                    getItemPrice(product);

                  const title = isPartner
                    ? (
                        product?.name ||
                        product?.title ||
                        'Partner Offering'
                      )
                    : (
                        product?.title ||
                        'Product'
                      );


                  return (

                    <div
                      className="card-body"
                      key={`${product.cartType}-${product._id || index}`}
                    >

                      <div className="">

                        <div className="product-card">


                          {/* =================================
                              IMAGE / VIDEO
                          ================================= */}

                          <div className="img-container">

                            {isPartner ? (

                              product?.mainImage ? (

                                <img
                                  className="product-card-img-top"
                                  src={product.mainImage}
                                  alt={title}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                  }}
                                />

                              ) : (

                                <div
                                  className="bg-secondary d-flex align-items-center justify-content-center text-white"
                                  style={{
                                    height: '100%'
                                  }}
                                >
                                  No Image
                                </div>

                              )

                            ) : (

                              product?.video?.youtubeTrailerId ? (

                                <iframe
                                  className='video'
                                  title='Youtube player'
                                  ClassName="product-card-img-top"
                                  src={`https://youtube.com/embed/${product.video.youtubeTrailerId}?autoplay=0`}
                                >
                                </iframe>

                              ) : (

                                <div
                                  className="bg-secondary d-flex align-items-center justify-content-center text-white"
                                  style={{
                                    height: '100%'
                                  }}
                                >
                                  No Image
                                </div>

                              )

                            )}

                          </div>


                          {/* =================================
                              PRODUCT DETAILS
                          ================================= */}

                          <div className="product-card-body">

                            <div>

                              <div className='product-card-body-details'>

                                <div>

                                  {/* Cart type */}

                                  <small
                                    style={{
                                      color: isPartner
                                        ? '#7b1fa2'
                                        : '#555',
                                      fontWeight: '600'
                                    }}
                                  >
                                    {isPartner
                                      ? `Partner ${
                                          product?.offeringKind ||
                                          'Offering'
                                        }`
                                      : 'Artist Product'}
                                  </small>


                                  <h5 className="product-card-text-title">
                                    {title}
                                  </h5>

                                </div>


                                <p className="product-cardproduct-price">

                                  {price}

                                </p>

                              </div>


                              <div className="product-card-detail">

                                <Link
                                  to={
                                    isPartner
                                      ? `/partner-product-description/${product._id}`
                                      : `/product-description/${product._id}`
                                  }
                                  className="link-btn"
                                >
                                  View Description
                                </Link>

                              </div>


                              {/* =================================
                                  REMOVE BUTTON
                              ================================= */}

                              <button

                                onClick={() => {

                                  if (isPartner) {

                                    handleClearSinglePartnerItem(
                                      product._id
                                    );

                                  } else {

                                    handleClearSingleItem(
                                      product._id
                                    );

                                  }

                                }}

                                style={{
                                  backgroundColor: 'transparent',
                                  border: 'none',
                                  color: 'red',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '5px'
                                }}

                              >

                                <MdDelete />

                                Remove from cart

                              </button>


                            </div>

                          </div>

                        </div>

                      </div>

                    </div>

                  );

                })
              }

            </div>

          </div>


          {/* ================================================
              ORDER SUMMARY
          ================================================ */}

          <div className="cart-checkout">

            <div className="checkout-card">

              <div className="card-header">

                <h5>
                  Order Summary
                </h5>

              </div>


              <div className="card-body">

                <div className="d-flex justify-content-between mb-3">

                  <span>
                    Subtotal ({allCartItems.length} items)
                  </span>

                  <span>
                    ₹{cartTotal}
                  </span>

                </div>


                <div className="d-flex justify-content-between mb-3">

                  <span>
                    Shipping
                  </span>

                  <span>
                    Free
                  </span>

                </div>


                <hr />


                <div className="d-flex justify-content-between mb-3">

                  <strong>
                    Total
                  </strong>

                  <strong>
                    ₹{cartTotal}
                  </strong>

                </div>


                <Link
                  to="/Checkout"
                  className="cart-checkout-btn"
                  style={{
                    textDecoration: 'none'
                  }}
                >
                  Proceed to Checkout
                </Link>

              </div>

            </div>


            <div className="mt-3">

              <Link
                to="/marketplace"
                className="btn btn-outline-primary w-100"
              >
                Continue Shopping
              </Link>

            </div>

          </div>

        </div>

      </div>

    </>
  );
};

export default CartPage;